export const uiTestMenuI18n = {
  uiTest: 'DEV TEST',
  uiTestPage: {
    title: 'DEV TEST',
    description:
      '在真实业务 URL 上按用户操作运行测试，完成后返回本页并显示结果。',
    scenarioNhomKhachHang: 'TEST 客户分组（{count} 项功能）',
    scenarioNhomKhachHangHint:
      '真实页面 — 读取数据库，每次运行创建 2 个新分组，搜索/编辑/删除基于当前数据。',
    runButton: '运行',
    runAllButton: 'Start ALL',
    runGroupButton: '运行本组',
    runNewTabButton: '新标签页',
    groupCount: '{n} 个场景',
    runningOnPage: '正在真实页面上运行测试…',
    runningLiveBanner: 'UI 操作测试进行中 — 完成后将返回测试页',
    runningLiveBannerAll: 'Start ALL — 场景 {current}/{total} — 完成后将返回测试页',
    runAllResultTitle: 'Start ALL 结果',
    runAllResultSuccess: '完成 {n} 个场景 — 全部通过',
    runAllResultPartial: '完成 {n} 个场景 — {failed} 个场景失败',
    runAllScenarios: '场景: {n}',
    runAllScenarioList: '各场景',
    runTitleNhomKhachHang: '客户分组 TEST 结果',
    back: '返回测试列表',
    running: '运行中',
    done: '完成',
    logTitle: '详细日志',
    featureTitle: '各项功能',
    resultModalTitle: 'UI 操作测试结果',
    resultSuccess: '成功',
    resultPartial: '部分完成',
    resultFailed: '失败',
    resultPassed: '通过: {n}',
    resultSkipped: '跳过: {n}',
    resultFailedCount: '错误: {n}',
    resultTotal: '总计: {n}',
    resultClose: '关闭',
    failed: 'UI 操作测试失败',
    unknownScenario: '无效的测试场景',
    importFilesSection: '下载导入测试文件',
    importFilesSectionHint: '按真实数据生成 Excel（全部商品 × 当前价格表）用于导入测试。',
    importFilesDownload: '下载',
    importFilesDownloading: '生成中…',
    importFilesSuccess: '已下载 {file}（{rows} 行 × {books} 个价格表）',
    importFilesFailed: '无法生成导入测试文件',
    importFiles: {
      bangGiaHangHoaTitle: '导入商品价格表',
      bangGiaHangHoaHint: '矩阵：每行一个商品编码；从第3列起为当前价格表名称；测试售价自动生成。',
    },
  },
} as const
